

import Joi from "joi";

const schema = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(6).max(13).required(),
    password: Joi.string().min(6).required(),
    });

export default {
  data() {
    return {

      // errorMessage: '',

      errorMessage: '',
          // user : {
          //   username : "",
          //   password : ""
          // },

      form : {
                id : '',
                username : "",
                nama : '',
                hp: "",
                email: "",
                password : "",
                confirmPassword: "",
                id_pengguna: "",
            },

            id_pengguna: "",
     
      list_data: [],
            list_pengguna: [],

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data : true,
      file_path: this.$store.state.url.URL_APP + "uploads/",


      mdl_pass: false,
      mdl_add: false,
      mdl_edit: false,
      mdl_hapus : false,
      btn_add: false,
    }
  },
  watch: {
      user: {
          handler() {
              this.errorMessage = "";
          },
          deep: true
      }
    },
  methods: {

    onEditorChange(event) {
        console.log('onEditorChange')
      },


    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Pengguna + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },


    addData: function() {
      this.errorMessage = "";
        if (this.validUser()) {
            // Jika user sdh valid lakukan pengiriman data ke server
            const body = {
              username: this.form.username,
              password: this.form.password
            };
            this.signingUp = true;

            fetch(this.$store.state.url.URL_Pengguna + "signup", {
                method: "POST",
                body: JSON.stringify(this.form),
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            }).then((response) => {
                this.signingUp = false;
                if (response.ok) {
                    this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
                    this.getView();
                    // this.$router.push('/login');
                    // return response.json();
                }
                else{
                  return response.json().then(error => {
                    throw new Error(error.message);
                  });

                }
            })
            .catch((error) => {
              setTimeout(() => {
                this.signingUp = false;
                this.errorMessage = error.message;
              }, 1000);
            });
        }else{
          console.log("tidak valid");

        }

    },

    validUser : function(){
      if (this.form.password !== this.form.confirmPassword) {
        this.errorMessage = " Password dan Confirm Password harus sama.!";
          // this.Notify('Password dan Confirm Password harus sama.!', 'accent', 'clear');
          return false;
      }
      // Memulai proses validasi melalui skema Joi yang sebelumnya dibuat
      // req.body merupakan data yang di kirim oleh client dan schema merupakan skema joi yg di buat sebelumnya
      const body = {
              username: this.form.username,
              password: this.form.password
      };


      const result = schema.validate(body);

      console.log(result.error)

      if (result.error == null || result.error ==undefined) {
          return true;
      }

      if (result.error.message.includes("username")) {
          // jika pesan error yang dihasilkan mengandung char "username" maka
          this.errorMessage = " Username tidak valid (Min : 6 dan Max : 14 Karakter)";
        // this.Notify('Username tidak valid (Min : 6 dan Max : 14 Karakter)', 'accent', 'clear');
      } else {
        
          // this.Notify('Password tidak valid (Min : 6 Karakter)', 'accent', 'clear');
          this.errorMessage = " Password tidak valid (Min : 6 Karakter)";
        //   console.log(result.error);

      }
      return false;
    },


    editData : function(){
      fetch(this.$store.state.url.URL_Pengguna + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
                id : this.form.id,
                id_pengguna : this.form.id_pengguna,
                nama : this.form.nama,
                username : this.form.username,
                email: this.form.email,
                hp: this.form.hp
            })
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    editPass: function() {
      if (this.form.password !== this.form.confirmPassword) {
        this.errorMessage = " Password dan Confirm Password harus sama.!";
          // this.alertku('warning', 'Password dan Confirm Password Harus Sama!.');
//          return false;
      }
      else{
        this.errorMessage = '';
        fetch(this.$store.state.url.URL_Pengguna + "editPass", {
            method: "POST",
            headers: {
                'content-type' : 'application/json',
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.form.id,
                password : this.form.password,
            })
        }).then(res_data => {
            this.Notify('Sukses Merubah Data', 'info', 'check_circle_outline');
            this.getView();
        });

      }

    },

    removeData : function(a){
      // console.log(a);
      // console.log(b);
      fetch(this.$store.state.url.URL_Pengguna + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : a})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },
    selectData : function(data){
        this.form.id = data.id
        this.form.username = data.username
        this.form.nama = data.nama
        this.form.hp = data.hp
        this.form.email = data.email
        this.form.id_pengguna = data.id_pengguna
    },
    getPengguna: function() {
        fetch(this.$store.state.url.URL_Pengguna, {
            method: "GET",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            }
        })
        .then(res => res.json())
        .then(res_data => {
            // console.log('telasooooo')
        this.list_pengguna = res_data;
        console.log(res_data)
        });
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },


    // ====================================== PAGINATE ====================================
  },

  mounted () {
    this.getPengguna();
    this.getView();
  },
}
